module.exports = __webpack_public_path__ + "img/tournaments_1920.1be4d333.png";